// import logo from "./logo.svg";
import "./App.css";
import React from "react";
import Home from "./components/home";

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
